import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface AgendaConfirmationModalData {
    title?: string;
    messages: string[];
    confirmText?: string;
    cancelText?: string;
}

@Component({
    selector: 'app-agenda-confirmation-modal',
    templateUrl: './agenda-confirmation-modal.component.html',
    styleUrls: ['./agenda-confirmation-modal.component.scss']
})
export class AgendaConfirmationModalComponent {
    constructor(
        public dialogRef: MatDialogRef<AgendaConfirmationModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: AgendaConfirmationModalData
    ) { }

    onClose(): void {
        this.dialogRef.close(false);
    }
    onConfirm(): void {
        this.dialogRef.close(true);
    }
} 